import { Component } from '@angular/core';
import moment from 'moment';
import { NavController, Events, ViewController } from 'ionic-angular';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';

/**
 * Generated class for the CoCalendarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-reserve-calendar',
  templateUrl: 'co-reserve-calendar.html'
})
export class CoReserveCalendarComponent {

  currentMonth: any = Date;
  daysInThisMonth: any;
  daysInLastMonth: any;
  daysInNextMonth: any;
  currentDay: any = '';
  parentPage: any;
  fullDate: any;
  currentYearNum: number;
  currentMonthNum: number;
  todaysMonthNum: number;
  todaysYearNum: number;
  todaysDayOfMonth: number;

  constructor(public navParams: NavParams, public navCtrl: NavController, private events : Events, private timeout : TimeoutFunctionsProvider, private viewCtrl : ViewController) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
  }

  ngOnInit() {
    if (this.navParams.data) {
      this.goToMonth(this.navParams.data.currentDay);
      this.parentPage = this.navParams.data.reservePage;
    }
    this.todaysMonthNum = moment().month();
    this.todaysYearNum = moment().year();
    this.todaysDayOfMonth = moment().date();
  }

  getDaysOfMonth() {

    this.daysInThisMonth = new Array();
    this.daysInLastMonth = new Array();
    this.daysInNextMonth = new Array();

    var firstDayThisMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), 1).getDay();
    var prevNumOfDays = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), 0).getDate();
    for (let i = prevNumOfDays - (firstDayThisMonth - 1); i <= prevNumOfDays; i++) {
      this.daysInLastMonth.push('');
    }

    var thisNumOfDays = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 0).getDate();
    for (let i = 0; i < thisNumOfDays; i++) {
      this.daysInThisMonth.push(i + 1);
    }

    var lastDayThisMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 0).getDay();
    var totalDays = this.daysInLastMonth.length + this.daysInThisMonth.length + this.daysInNextMonth.length;
    if (totalDays < 36) {
      for (let i = (7 - lastDayThisMonth); i < ((7 - lastDayThisMonth) + 7); i++) {
        this.daysInNextMonth.push('');
      }
    }
  }

  goToMonth(date: string) {
    this.fullDate = moment(date);
    this.currentDay = this.fullDate.date();
    this.currentMonth = new Date(moment(date).year(), moment(date).month(), this.currentDay);

    this.currentMonthNum = this.fullDate.month();
    this.currentYearNum = this.fullDate.year();

    this.getDaysOfMonth();
  }

  goToLastMonth() {
    let newDate = this.fullDate.subtract(1,'month').date(1).format("YYYY-MM-DD HH:mm:ss");
    this.currentMonthNum = moment(newDate).month();
    this.currentYearNum = moment(newDate).year();

    if (this.currentMonthNum === moment().month() && this.currentYearNum === moment().year()) {
      newDate = moment(this.fullDate).date(this.todaysDayOfMonth).format("YYYY-MM-DD HH:mm:ss");
    }

    this.goToMonth(newDate);
    this.parentPage.goToDate(newDate);
  }

  goToNextMonth() {
    let newDate = this.fullDate.add(1,'month').date(1).format("YYYY-MM-DD HH:mm:ss");
    this.currentMonthNum = moment(newDate).month();
    this.currentYearNum = moment(newDate).year();

    if (this.currentMonthNum === moment().month() && this.currentYearNum === moment().year()) {
      newDate = moment(this.fullDate).date(this.todaysDayOfMonth).format("YYYY-MM-DD HH:mm:ss");
    }

    this.goToMonth(newDate);
    this.parentPage.goToDate(newDate);
  }

  changeSelectedDate(data: any) {
    this.currentDay = new Date(moment(this.currentMonth).year(), moment(this.currentMonth).month(), data.toElement.innerText).getDate();
    this.parentPage.goToDate(moment(this.currentMonth).date(parseInt(data.toElement.innerText)).hour(moment().hour()).minute(moment().minute()).format("YYYY-MM-DD HH:mm:ss"));
    this.viewCtrl.dismiss(false, "", {animate: false});
  }
}


// WEBPACK FOOTER //
// ./src/components/co-reserve-calendar/co-reserve-calendar.ts